import { render, staticRenderFns } from "./DeadCintilloAlaGrid.vue?vue&type=template&id=8ca02b5a&scoped=true"
import script from "./DeadCintilloAlaGrid.vue?vue&type=script&lang=js"
export * from "./DeadCintilloAlaGrid.vue?vue&type=script&lang=js"
import style0 from "./DeadCintilloAlaGrid.vue?vue&type=style&index=0&id=8ca02b5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ca02b5a",
  null
  
)

export default component.exports